import { Component, OnInit, ElementRef, ViewChild, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";

@Component({
  selector: '[mft-inv-nav]',
  templateUrl: './invoicingdetail.navigation.component.html'
})
export class InvoicingDetailNavigationComponent implements OnInit {
  @Input() invoiceName: string;

  constructor(public headerAndNavigationService: HeaderAndNavigationService   
  ) { }

  ngOnInit(): void {
    
  }

  ngAfterViewInit() {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicingdetail.navigation.component.ts